import { ReactElement } from "react";
import styles from "./ExpandableTitlebar.module.less";
import { useCallbackWithoutArguments } from "client/Hooks";
import { IconButtonLike } from "../IconButton/IconButtonLike";
import { isNotNilOrWhiteSpace, setTrackingId } from "client/Misc/utils";
import { Tag } from "../Tag/Tag";

export type ExpandableTitlebarProps = {
	text: string;
	isExpanded: boolean;
	onToggle: () => void;
	tag?: string;
	trackingId: string;
};

export const ExpandableTitlebar = (props: ExpandableTitlebarProps): ReactElement => {
	const {
		text,
		isExpanded,
		onToggle: onToggleFromProps,
		tag,
		trackingId
	} = props;

	const onToggle: () => void = useCallbackWithoutArguments(onToggleFromProps);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
			onClick={onToggle}
		>
			<h3 className={styles.text} title={text}>
				{text}
			</h3>

			{isNotNilOrWhiteSpace(tag) && (
				<Tag text={tag} color="secondary" />
			)}

			<IconButtonLike
				shape="round"
				kind="transparent"
				icon={isExpanded ? "chevron-up" : "chevron-down"}
				trackingId="expand-collapse-button"
			/>
		</div>
	);
};
ExpandableTitlebar.displayName = "ExpandableTitlebar";
